<template>
    <section class="page-section section-photo-cards">
        <div class="container">
            <a :href="button_link" :title="stripHtml(button_text)" class="ingka-card">
                <div v-if="section_image" class="ingka-card__image">
                    <img :src="section_image" alt="" />
                </div>
                <div class="ingka-card__body">
                    <div class="ingka-card__title" v-safe-html="button_text"></div>
                    <span class="ingka-card__arrow" aria-hidden="true">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <line x1="5" y1="12" x2="19" y2="12" />
                            <polyline points="12 5 19 12 12 19" />
                        </svg>
                    </span>
                </div>
            </a>
        </div>
    </section>
</template>

<script>

export default {
    props: {
        section_image: String,
        button_title: String,
        button_text: String,
        button_link: String,
    },
    data() {
        return {
            image: require('@/assets/404.jpg'),
        }
    },
    methods: {
        stripHtml(value) {
            return value ? String(value).replace(/<[^>]*>/g, '') : '';
        },
    },
};
</script>

<style>
/* Ingka-style card: image on top, light-gray body, dark title, circular arrow. */
.section-photo-cards .ingka-card {
    display: block;
    text-decoration: none;
    color: inherit;
    background-color: #f5f5f5;
    border-radius: 6px;
    overflow: hidden;
    transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.section-photo-cards .ingka-card:hover {
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.12);
    transform: translateY(-3px);
}

.section-photo-cards .ingka-card__image img {
    display: block;
    width: 100%;
    height: 280px;
    object-fit: cover;
}

.section-photo-cards .ingka-card__body {
    padding: 28px 28px 32px;
    text-align: left;
}

.section-photo-cards .ingka-card__title,
.section-photo-cards .ingka-card__title p {
    color: #111111;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.3;
    margin: 0 0 24px;
}

.section-photo-cards .ingka-card__arrow {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background-color: #111111;
    color: #fff;
    flex-shrink: 0;
}

.section-photo-cards .ingka-card:hover .ingka-card__arrow {
    background-color: #333333;
}
</style>
